import { Component, ChangeDetectionStrategy, inject } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { ElderShellService } from '@elderbyte/ngx-starter'
import { Vendor } from '../../vendor'
import { VendorDetailComponent } from '../vendor-detail/vendor-detail.component'

@Component({
  selector: 'app-vendor-detail-side',
  templateUrl: './vendor-detail-side.component.html',
  styleUrls: ['./vendor-detail-side.component.scss'],
  imports: [VendorDetailComponent],
})
export class VendorDetailSideComponent {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  public vendor: Vendor
  private route = inject(ActivatedRoute)
  private shellService = inject(ElderShellService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.vendor = this.route.snapshot.data['vendor']
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public onClose(event: Event): void {
    this.shellService.closeSideContent()
  }
}
